import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadLeadForm } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type GetLeadFormParams = {
  landingPageId: string;
};

export const getLeadForm = async (
  params: GetLeadFormParams,
): Promise<ReadLeadForm> => {
  return await tinctApi.leadForms.getLeadForm(params.landingPageId);
};

export const useGetLeadForm = (
  params: GetLeadFormParams,
  options?: Omit<UseQueryOptions<ReadLeadForm, ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: ['lead-form', params.landingPageId],
    queryFn: () => getLeadForm(params),
    ...options,
  });
